import React from "react";
import PropTypes from "prop-types";

const PageBase = ({
  title,
  actions,
  toolbar,
  footer,
  children,
  className = "",
  card = true,
  contentClassName = "",
  containerProps = {},
  ...rest
}) => {
  const { className: containerClassName, ...restContainerProps } = containerProps;

  return (
    <div className={`page-root ${className}`} data-page-base="true" {...rest}>
      {card ? (
        <div
          className={`page-main-card ${contentClassName} ${containerClassName || ""}`}
          data-page-main-card="true"
          {...restContainerProps}
        >
          {(title || actions) && (
            <div className="page-card-header">
              {title && <h1 className="page-title">{title}</h1>}
              {actions && <div className="page-card-actions">{actions}</div>}
            </div>
          )}

          {toolbar && (
            <div className="page-card-toolbar">{toolbar}</div>
          )}

          <div className="page-card-content">
            {children}
          </div>

          {footer && (
            <div className="page-card-footer">{footer}</div>
          )}
        </div>
      ) : (
        <div
          className={`${contentClassName} ${containerClassName || ""}`}
          {...restContainerProps}
        >
          {(title || actions) && (
            <div className="page-header">
              {title && <h1 className="page-title">{title}</h1>}
              {actions && <div className="page-actions">{actions}</div>}
            </div>
          )}

          {toolbar && (
            <div className="page-toolbar">{toolbar}</div>
          )}

          {children}
        </div>
      )}
    </div>
  );
};

PageBase.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  actions: PropTypes.node,
  toolbar: PropTypes.node,
  footer: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
  card: PropTypes.bool,
  contentClassName: PropTypes.string,
  containerProps: PropTypes.object,
};

export default PageBase;
